import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { AuthenticationServiceImpl } from '../http/impl/authentication.service.impl';
import { LocalStorageHelper } from './local.storage.helper';
import { LOCAL_STORAGE_CONSTANTS } from '../constants/local.storage.constants';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SessionCheckerHelper {
	public observersSessionExpired: Array<any> = [];
	public observersUserInactivity: Array<any> = [];
	public limitSecondsInactivity: any = 0;
	public limitSecondsBeforeNotifyInactivity: any = 0;
	public counterInactivity: any = 0;
	public intervalChecker: any;
	public previousTitle: string = '';

	constructor(public jwtHelper: JwtHelperService,
		public autenticationService: AuthenticationServiceImpl,
		public localStorageService: LocalStorageHelper,
		public windowTitleService: Title) {

		this.observersSessionExpired = [];
		this.observersUserInactivity = [];
		this.limitSecondsInactivity = environment.limitSecondsInactivity;
		this.limitSecondsBeforeNotifyInactivity = environment.limitSecondsBeforeNotifyInactivity;
		this.counterInactivity = 0;
		this.previousTitle = windowTitleService.getTitle();
	}

	public clearInactivity() {
		this.counterInactivity = 0;
		this.windowTitleService.setTitle(this.previousTitle);
	}

	public onJwtSessionExpired(cb: any) {

		if (!this.intervalChecker) {
			this.intervalChecker = setInterval(this.checker.bind(this), environment.timeIntervalChecker);
		}
		this.observersSessionExpired.push(cb);
	}

	public onInactivityUser(cb: any) {
		if (!this.intervalChecker) {
			this.intervalChecker = setInterval(this.checker.bind(this), environment.timeIntervalChecker);
		}

		this.observersUserInactivity.push(cb);
	}

	public checker() {
		const { USER } = LOCAL_STORAGE_CONSTANTS;
		const existUserOnLocalStorage = this.localStorageService.existsItem('user');
		if (!this.autenticationService.isValidSession() && existUserOnLocalStorage) {
			return this.notifyObserversJWT.bind(this)();
		}

		if (this.autenticationService.isValidSession() && this.counterInactivity >= this.limitSecondsInactivity) {
			return this.notifyObserversInactivity.bind(this)();
		}

		if (this.autenticationService.isValidSession() && this.counterInactivity >= this.limitSecondsBeforeNotifyInactivity) {
			this.notifyInactivity.bind(this)();
		}

		this.counterInactivity++;
	}

	public notifyInactivity() {
		const secondRest = this.limitSecondsInactivity - this.counterInactivity;
		const message = `${secondRest}seg ⏳ para cerrar Sesion`;
		this.windowTitleService.setTitle(message);
	}


	public notifyObserversJWT() {
		this.observersSessionExpired.forEach((currentCallback: any) => {
			currentCallback();
		});
	}

	public notifyObserversInactivity() {
		this.windowTitleService.setTitle(this.previousTitle);
		this.observersUserInactivity.forEach((currentCallback: any) => {
			currentCallback();
		})
	}
}
